import { formatMoney } from 'accounting'

import { Form } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import handleCallbackAction from '@functions/handleCallbackAction'

import { InvoiceItemModel } from '@models/invoiceItem'
import type { InvoiceModel } from '@models/types'

import useInvoice, { useInvoiceForm } from '@hooks/useInvoice'
import type { UseInvoicePayload } from '@hooks/useInvoice'

const handleInvoiceUpdate = (
  entityState: Partial<InvoiceModel>,
  updateInvoice: UseInvoicePayload['callbacks']['updateInvoice'],
) => {
  const updateInvoicePayload: HandleCallbackActionParams = {
    callbacks: {
      action: updateInvoice,
    },
    entityParams: entityState,
    toastText: 'Invoice Updated',
  }

  handleCallbackAction(updateInvoicePayload)
}

interface AmountColumnProps {
    invoice: InvoiceModel,
    invoiceItem: InvoiceItemModel & { text: string },
    totalAmount: number,
}

const AmountColumn = (props: AmountColumnProps) => {
  const { invoice, invoiceItem, totalAmount } = props

  const { quantity, price, text } = invoiceItem
  const total = (quantity ?? 0) * (price ?? 0)

  const disabled = invoice.approved || invoice.void

  const invoicePayload = useInvoice(invoice)
  const {
    callbacks: {
      updateInvoice,
    },
  } = invoicePayload

  const invoiceFormPayload = useInvoiceForm(invoice)
  const { setEntityState, entityState } = invoiceFormPayload

  if (text === 'Override Total'){
    return (
      <Form.Field style={{ textAlign: 'right' }}>
        <input
          disabled={disabled}
          name="total"
          type="number"
          onBlur={e => handleInvoiceUpdate({ total: +e.target.value }, updateInvoice)}
          onChange={e => setEntityState({ total: +e.target.value })}
          value={entityState.total}
          placeholder="$0"
          style={{ textAlign: 'right', width: '100px' }}
        />
      </Form.Field>
    )
  }

  return (formatMoney(totalAmount || total))
}

export default AmountColumn
